import { render, staticRenderFns } from "./view-MT4-phone.vue?vue&type=template&id=8b7e3010&scoped=true&"
import script from "./view-MT4-phone.vue?vue&type=script&lang=js&"
export * from "./view-MT4-phone.vue?vue&type=script&lang=js&"
import style0 from "./view-MT4-phone.vue?vue&type=style&index=0&id=8b7e3010&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7e3010",
  null
  
)

export default component.exports